module.exports = __webpack_public_path__ + "static/visiting families-5b42490c0b4f685d6f149808281a1803.svg";